import stones from "../../api/stones";

const state = () => ({
  results: [],
  isLoading: true,
  selectedStone: {},
  total: 0,
  query: {},
  shapes: [
    { value: 'ROUND', active: false },
    { value: 'PRINCESS', active: false },
    { value: 'CUSHION', active: false },
    { value: 'OVAL', active: false },
    { value: 'PEAR', active: false },
    { value: 'EMERALD', active: false },
    { value: 'HEART', active: false },
    { value: 'RADIANT', active: false },
    { value: 'ASSCHER', active: false },
    { value: 'MARQUISE', active: false },
    //{ value: 'SHIELD', active: false },
    { value: 'TRIANGULAR', active: false },
  ],
  fancyOvertoneOptions: [
    { value: "None", key: "fancy_overtone.none" },
    { value: "Yellow", key: "fancy_overtone.yellow" },
    { value: "Yellowish", key: "fancy_overtone.yellowish" },
    { value: "Pink", key: "fancy_overtone.pink" },
    { value: "Pinkish", key: "fancy_overtone.pinkish" },
    { value: "Blue", key: "fancy_overtone.blue" },
    { value: "Blueish", key: "fancy_overtone.blueish" },
    { value: "Red", key: "fancy_overtone.red" },
    { value: "Reddish", key: "fancy_overtone.reddish" },
    { value: "Green", key: "fancy_overtone.green" },
    { value: "Greenish", key: "fancy_overtone.greenish" },
    { value: "Purple", key: "fancy_overtone.purple" },
    { value: "Purplish", key: "fancy_overtone.purplish" },
    { value: "Orange", key: "fancy_overtone.orange" },
    { value: "Orangey", key: "fancy_overtone.orangey" },
    { value: "Violet", key: "fancy_overtone.violet" },
    { value: "Gray", key: "fancy_overtone.gray" },
    { value: "Grayish", key: "fancy_overtone.grayish" },
    { value: "Black", key: "fancy_overtone.black" },
    { value: "Brown", key: "fancy_overtone.brown" },
    { value: "Brownish", key: "fancy_overtone.brownish" },
    { value: "Champagne", key: "fancy_overtone.champagne" },
    { value: "Cognac", key: "fancy_overtone.cognac" },
    { value: "Chameleon", key: "fancy_overtone.chameleon" },
    { value: "White", key: "fancy_overtone.white" },
    { value: "Other", key: "fancy_overtone.other" }
  ],
  fancyColorOptions: [
    { value: "Yellow", key: "fancy_color.yellow" },
    { value: "Pink", key: "fancy_color.pink" },
    { value: "Blue", key: "fancy_color.blue" },
    { value: "Red", key: "fancy_color.red" },
    { value: "Green", key: "fancy_color.green" },
    { value: "Purple", key: "fancy_color.purple" },
    { value: "Orange", key: "fancy_color.orange" },
    { value: "Violet", key: "fancy_color.violet" },
    { value: "Gray", key: "fancy_color.gray" },
    { value: "Black", key: "fancy_color.black" },
    { value: "Brown", key: "fancy_color.brown" },
    { value: "Champagne", key: "fancy_color.champagne" },
    { value: "Cognac", key: "fancy_color.cognac" },
    { value: "Chameleon", key: "fancy_color.chameleon" },
    { value: "White", key: "fancy_color.white" },
    { value: "Other", key: "fancy_color.other" }
  ],
  fancyIntensityOptions: [
    { value: "Faint", key: "fancy_intensity.faint" },
    { value: "Very_Light", key: "fancy_intensity.very_light" },
    { value: "Light", key: "fancy_intensity.light" },
    { value: "Fancy_Light", key: "fancy_intensity.fancy_light" },
    { value: "Fancy", key: "fancy_intensity.fancy" },
    { value: "Fancy_Dark", key: "fancy_intensity.fancy_dark" },
    { value: "Fancy_Intense", key: "fancy_intensity.fancy_intense" },
    { value: "Fancy_Vivid", key: "fancy_intensity.fancy_vivid" },
    { value: "Fancy_Deep", key: "fancy_intensity.fancy_deep" },
  ],
  certificateLab: ["IGI", "GIA", "HRD", "EGL"],
});

// getters
const getters = {
  getQuery(state) {
    return state.query;
  },
};

// actions
const actions = {
  fetchResults({ commit }, search) {
    commit("setIsLoading", true);
    stones.search(search).then((data) => {
      commit("setResults", data.data?.items);
      commit("setIsLoading", false);
      search.cb();
    }).catch(error => {
      commit("setIsLoading", false);
      search.cb();
    })
  },

  initResults({ commit, dispatch }, search) {
    commit("setIsLoading", true);
    Promise.all([stones.count(search), stones.search(search)]).then(values => {
      commit("setTotal", values[0].data);
      commit("setResults", values[1].data?.items);
      commit("setIsLoading", false);
      search.cb();
    }).catch(error => {
      commit("setIsLoading", false);
      search.cb();
    })
  },

  selectStone({ commit }, stone) {
    commit("setSelectedStone", stone);
  },

  setQuery({ commit }, query) {
    commit("setQuery", query);
  },

  resetResults({ commit }) {
    commit("setResults", []);
  },
};

// mutations
const mutations = {
  setResults(state, value) {
    state.results = value;
  },
  setIsLoading(state, value) {
    state.isLoading = value;
  },
  setSelectedStone(state, value) {
    state.selectedStone = value;
  },
  setTotal(state, value) {
    state.total = value;
  },
  setQuery(state, value) {
    state.query = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
